import React, {Component} from 'react'
import PaymentTermEditForm from "./form/edit.component.jsx"
import {AppContext} from '@lightspeed-invoicing/core-client/frontend'
import SideBar from '../common/layout/sidebar.component.jsx'

class PaymentTermEdit extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            user: {},
            form: '',
        }
    }

    componentDidMount() {
        SideBar.activateMenu('account')

        const paymentTermId = this.props.match.params.paymentTermId
        AppContext.getApiClient().get('/payment-terms/' + paymentTermId).then(term => {
            const form = <PaymentTermEditForm paymentTerm={term} />
            this.setState({
                form: form
            })
        });
    }

    render() {
        return (
            <div>
                {this.state.form}
            </div>
        );
    }
}

export default PaymentTermEdit


// WEBPACK FOOTER //
// ./src/payment-term/edit.component.jsx